import { TileVisibility, WorldTile } from "../../engine/map/LevelMap";
import { TILE_TYPES } from "../../tiles";
import { RDisplay } from "../../ui/RotDisplay";
import Colors from "../Colors";
import { gameData } from "../GameManager";

export enum FloorTypes {
  EMPTY,
  CHASM,
  OOB,
}

export enum AdjTypes {
  OPEN,
  WALL,
  ONE_OUT,
  ONE_IN,
  Z_OUT,
  Z_IN,
}

const VISIBLE_THEME = {
  wall: Colors.B_GREY_5,
  floor: Colors.BROWN_1,
  bgs: [Colors.BROWN_1, Colors.BROWN_2, Colors.BROWN_3, Colors.RED_2],
};

const SEEN_THEME = {
  wall: Colors.B_GREY_5,
  floor: Colors.GREY_1,
  bgs: [Colors.GREY_1, Colors.GREY_2, Colors.GREY_3, Colors.RED_2],
};

export const drawTile = (
  display: RDisplay,
  x: number,
  y: number,
  tile: WorldTile<FloorTypes, AdjTypes>,
  visibility: TileVisibility
) => {
  //if (visibility === TileVisibility.HIDDEN) {
  //  return;
  //}
  const theme =
    visibility === TileVisibility.VISIBLE || gameData.seeAll
      ? VISIBLE_THEME
      : SEEN_THEME;

  switch (tile.type) {
    case FloorTypes.EMPTY:
      display.draw(x, y, TILE_TYPES.EMPTY, theme.floor, theme.bgs[tile.z]);
      break;
    case FloorTypes.OOB:
      display.draw(x, y, " ", Colors.BLACK, Colors.BLACK); //Draw oob tile for background color
      break;
  }

  let wallType = null;
  if (tile.adj.up === AdjTypes.WALL && tile.adj.left === AdjTypes.WALL) {
    wallType = TILE_TYPES.UL_;
  } else if (tile.adj.up === AdjTypes.WALL) {
    wallType = TILE_TYPES.U_;
  } else if (tile.adj.left === AdjTypes.WALL) {
    wallType = TILE_TYPES.L_;
  }

  if (wallType) {
    display.drawAppend(x, y, wallType, theme.wall, "transparent");
  }

  if (tile.adj.left === AdjTypes.Z_IN) {
    display.drawAppend(
      x,
      y,
      TILE_TYPES._L,
      theme.bgs[tile.z + 1],
      "transparent"
    );
  }
  if (tile.adj.up === AdjTypes.Z_IN) {
    display.drawAppend(
      x,
      y,
      TILE_TYPES._U,
      theme.bgs[tile.z + 1],
      "transparent"
    );
  }
  if (tile.adj.right === AdjTypes.Z_IN) {
    display.drawAppend(
      x,
      y,
      TILE_TYPES._R,
      theme.bgs[tile.z + 1],
      "transparent"
    );
  }
  if (tile.adj.down === AdjTypes.Z_IN) {
    display.drawAppend(
      x,
      y,
      TILE_TYPES._D,
      theme.bgs[tile.z + 1],
      "transparent"
    );
  }
};
